export const takeoffServices = [
  {
    id: 1,
    title: 'Material Takeoff & Estimation',
    description: 'Comprehensive material quantity takeoffs with detailed cost estimation for construction projects. Includes lumber, concrete, steel, finishes, and all building materials with accurate measurements and pricing.',
    image: 'https://placehold.co/600x400',
    tags: ['Quantity Surveying', 'Cost Estimation', 'Material Lists', 'Budget Planning'],
    features: [
      'Detailed material quantities',
      'Cost breakdown analysis',
      'Supplier pricing integration',
      'Waste factor calculations'
    ]
  },
  {
    id: 2,
    title: 'Labor & Time Estimation',
    description: 'Accurate labor hour calculations and workforce planning for construction projects. Detailed analysis of man-hours required, crew sizing, and project timeline estimation based on industry standards.',
    image: 'https://placehold.co/600x400',
    tags: ['Labor Analysis', 'Time Management', 'Crew Planning', 'Productivity Rates'],
    features: [
      'Man-hour calculations',
      'Crew size optimization',
      'Timeline projections',
      'Productivity analysis'
    ]
  },
  {
    id: 3,
    title: 'Cost Analysis & Budgeting',
    description: 'Complete project cost analysis including materials, labor, equipment, and overhead. Detailed budget breakdowns with contingency planning and value engineering recommendations for optimal project economics.',
    image: 'https://placehold.co/600x400',
    tags: ['Budget Planning', 'Cost Control', 'Value Engineering', 'Financial Analysis'],
    features: [
      'Complete cost breakdowns',
      'Budget vs actual tracking',
      'Value engineering options',
      'Contingency planning'
    ]
  }
];